import { useCallback, useEffect, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useRect } from 'hooks/useRect';
import { getPage } from 'store/page/thunks';

export function useBuilderPagePreview({ pagePreviewId: pageId }) {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(null);
  const wrapperRef = useRef(null);
  const { height } = useRect(wrapperRef);

  const toggleWindow = useCallback(() => {
    setVisible((val) => !val);
  }, []);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        setIsLoading(true);
        const pageData = await dispatch(getPage(pageId, true));

        setPage(pageData);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPage();
  }, [dispatch, pageId]);

  return {
    visible,
    isLoading,
    page,
    wrapperRef,
    height,
    toggleWindow,
  };
}
